<template>
    <div class="bottom">
        <div class="bottom_con">
            <div class="bottom_left">
                <img class="logoImg" src="@/assets/logo/logo.png" />
                <div class="guanzhu">关注我获取产品最新动态</div>
                <div class="bottom-ewm txhz">
                    <div class="wxewm" v-if="wxUrl!=''">
                        <img class="ewmImg" :src="wxUrl" alt="">
                        <div>微信公众号</div>
                    </div>
                    <div class="wxewm" v-if="kfUrl!=''">
                        <img class="ewmImg" :src="kfUrl" alt="">
                        <div>客服二维码</div>
                    </div>
                </div>
            </div>
            <div class="bottom-right">
                <div class="bottom-nav">
                    <div class="bbbitoti">快速导航</div>
                    <div>
                        <div
                            class="bottom_nav"
                            v-for="(item, index) in nav"
                            :key="index"
                            @click="handleClick(index, item.url)"
                        >
                            {{ item.tit }}
                            </div>
                    </div>
                    
                </div>

                <div class="bottom-lx">
                    <div class="bbbitoti">联系我们</div>
                    <div>
                        <div class="bottom_nav naver">联系电话：{{form.phone||''}}</div>
                        <div class="bottom_nav naver">电子邮箱：{{form.email||''}}</div>
                        <div class="bottom_nav naver">公司地址：{{form.address||''}}</div>
                    </div>
                </div>
            </div>
        </div>
        
        <div class="bottom_line"></div>
        <div class="Copyright">
            Copyright © 2026 xiaohezy.com All rights reserved. 小荷智运（鲁ICP备2026012092号-1）版权所属：小荷智运物流科技（青岛）有限公司
        </div>
    </div>
</template>

<script>
import { 
    getContactUsInfo,
    getQrCode,
} from "@/api/api";

export default {
    data() {
        return{
            nav: [
              {
                tit: "首页",
                url: "/index",
              },
              {
                tit: "关于我们",
                url: "/about_us",
              },
              {
                tit: "新闻动态",
                url: "/news",
              },
              {
                tit: "产品下载",
                url: "/download",
              }
            ],

            form:{},

            wxUrl:'',
            kfUrl:'',
        }
    },
    methods:{
        // 点击导航栏
        handleClick(index, url) {
            sessionStorage.setItem("menu", index);
            
            if (this.$route.path != url) {
                this.$router.push(url);
            } else {
                window.scrollTo(0, 0);
            }
        },
        async getInfo(){
            try {
                const res = await getContactUsInfo()
                this.form = res.data
            } catch (error) {
                console.log(error,'error');
            }
        },
        async getErwm(){
            try {
                const res = await getQrCode()
                this.wxUrl = res.data.wechat_official_account
                this.kfUrl = res.data.customer_service
            } catch (error) {
                console.log(error,'error');
            }
        }
    },
    mounted(){
        this.getInfo()
        this.getErwm()
    }
}
</script>

<style lang="scss" scoped>
.bottom{
    padding: 32px 160px;
    background: #101828;

  
    .Copyright{
        color: #99A1AF;
        font-size: 16px;
        font-weight: 400;
        text-align: center;
    }

    .bottom_con{
        display: flex;
        justify-content: space-between;
    }
}

.bottom_left{
    .logoImg{
        width: 96px;
        height: 32px;
    }

    .guanzhu{
        margin-top: 18px;
        color: #99A1AF;
        font-size: 16px;
        margin-bottom: 16px;
    }

    .wxewm{
        margin-right: 32px;
        text-align: center;
        color: #FFF;
        font-size: 14px;
        text-align: center;
        .ewmImg{
            margin-bottom: 8px;
            width: 120px;
            height: 120px;
            background: #FFF;
        }
    }
}

.bottom-right{
    margin-top: 44px;
    display: flex;
    .bbbitoti{
        color: #FFF;
        font-size: 16px;
        margin-bottom: 16px;
    }

    .bottom_nav{
        cursor: pointer;
        margin-right: 148px;
        color: #99A1AF;
        font-size: 14px;
        margin-bottom: 12px;
    }

    .naver{
        width: 248px;
    }
}

.bottom_line{
    height: 2px;
    opacity: 0.2;
    background: #FFF;
    margin-top: 32px;
    margin-bottom: 32px;
}

.txhz{
    display: flex;
    align-items: center;
}
</style>